import axios from "axios";
import { cookie } from 'react-cookie';
import apipaths from "@Core/Apis/apiPaths";

const self = {
        method: "GET",
	headers: {
		'Content-Type' : 'application/json'
	},
	fingerPrint : '',
	setMethod: function(method) {
		self.method = method;
		return self;
	},
	setHeader: function(key, value) {
		self.headers[key] = value;
		return self;
	},
	reset: function() {
        self.method = "GET";
        self.headers = {"Content-Type" : "application/json"};
        return self;
        },
	setFingerPrint : function(fingerPrint){
		self.fingerPrint = fingerPrint;
		return self;
	},
	setAuthToken: function (token) {
		if (token) {
		  self.headers["Authorization"] = `Bearer ${token}`;
		} else {
		  delete self.headers["Authorization"]; // agar token nahi mila to remove kar do
		}
		return self;
	  },
        sendRequest: function(url, data, authenticate, callback, dispatch, responseType = 'json') {
		return axios({
			method: self.method,
            crossOriginIsolated :true,
			url: apipaths.BASE_URL + url,
			responseType,
			headers: self.headers,
			data: data,
			timeout : 240000,
			params: (self.method == "GET") ? data : {}
		})
		.then(function (response) {
				self.reset();
				if(responseType == 'blob' && response.status !== 200) {
					throw new Error('Download Error')
				}
				else if (authenticate) {
					if (response.data.code === "CEC4007") {

						dispatch({
							type:'connectionRemoved',
							data:true
						});
					}
				}

			callback(response);
		})
		.catch(function (error) {
			callback(error.response);
		});
	}
}
    
export default self;